import React from "react";
import { Button, Icon } from "Components";
import "./emptystate.scss";

interface EmptyStateProps {
    title: string;
    description: string;
    actionLabel?: string | null;
    onAction?: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({
    title,
    description,
    actionLabel = "Create Campaign",
    onAction,
}) => {
    return (
        <div className="pm-empty-card">
            <div className="pm-empty-icon-wrapper">
                <Icon type="noCampaign" />
            </div>
            <div className="pm-empty-content-wrapper">
                <div className="pm-empty-title">{title}</div>
                <div className="pm-empty-description">{description}</div>
            </div>
            {actionLabel && <Button shape="round" type="primary" onClick={onAction}>{actionLabel}</Button>}
        </div>
    );
};

export default EmptyState;